enum Mutation {
  SET_PAYLOAD = 'setPayload',
}

export default Mutation;
